// src/constants/fileUploadLimits.js

/**
 * Maximum file size for general document uploads (e.g., ID copies, certificates).
 * 10MB
 */
export const MAX_DOCUMENT_SIZE_BYTES = 10 * 1024 * 1024;

/**
 * Maximum file sizes for course content uploads, categorized by type.
 */
export const MAX_CONTENT_FILE_SIZES = {
  video: 500 * 1024 * 1024, // 500MB
  document: 50 * 1024 * 1024, // 50MB
  image: 10 * 1024 * 1024, // 10MB
  audio: 100 * 1024 * 1024, // 100MB
};

/**
 * Accepted file extensions for general document uploads.
 */
export const DOCUMENT_ACCEPTED_FILE_EXTENSIONS = ['.pdf', '.jpg', '.jpeg', '.png'];

/**
 * Accepted MIME types for general document uploads.
 */
export const DOCUMENT_ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
];

/**
 * Accepted file extensions for course content uploads, categorized by type.
 */
export const CONTENT_ACCEPTED_FILE_TYPES = {
  video: '.mp4,.mov,.avi,.wmv,.flv,.webm,.mkv',
  document: '.pdf,.doc,.docx,.ppt,.pptx,.txt,.md,.rtf',
  image: '.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp',
  audio: '.mp3,.wav,.flac,.aac,.ogg,.m4a',
};

export const CONTENT_FILE_INPUT_ACCEPT = {
  ...CONTENT_ACCEPTED_FILE_TYPES,
  document: `${CONTENT_ACCEPTED_FILE_TYPES.document},application/pdf`,
};
